import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../../shared/components/api-operable/api-operable.component';
import { SortUtils } from '../../../../../shared/utils/sort.utils';
import { ProductSearchModel } from '../../../../product/model/product-search.model';
import { AuthService } from '../../../../security/service/auth.service';
import { ProductUIMessages } from '../../../model/product-ui.messages';
import { ProductModel } from '../../../model/product.model';
import { ProductService } from '../../../service/product.service';
import { KeywordsAddComponent } from '../keywords-add.component';
import { UIDialogService } from './../../../../../shared/services/ui-dialog.service';
@Component({
  selector: 'keywords-view',
  templateUrl:
    './console/app-js/modules/product/components/keywords/keywords-view/keywords-view.component.html'
})
export class KeywordsView extends APIOperableComponent implements OnInit {
  // @ViewChild('keywordDataTable')
  // keywordDataTable: DatatableComponent;
  @ViewChild(DatatableComponent, { static: true })
  public table: DatatableComponent;
  public currentPageLimit: Number = 1;
  public currentVisible: Number = 3;
  @Input('product') productModel: ProductModel;
  protected originalData: any[];
  private searchModel = new ProductSearchModel();
  protected searching = false;
  private keywords = [];
  constructor(
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    protected dialogService: UIDialogService,
    private productService: ProductService
  ) {
    super(progressService, toastr, authService);
  }
  ngOnInit(): void {
    this.loadKeywordData();
  }
  /**
   * Retrieves from endpoint current keyword linked to the product(this.product.id).
   */
  private loadKeywordData(): void {
    this.searchModel.results = [];
    this.originalData = null;
    this.progressRef.start(); // START PROGRESS
    this.searching = true;
    this.loadingIndicator = true;
    this.productService.getKeywordProductById(this.productModel.id).subscribe(
      (res: any) => {
        if (res.responseCode === 200 && res.results) {
          this.searchModel = this.productService.getSearchResultModel(
            this.searchModel,
            res
          );
          this.searchModel.results = SortUtils.sortCollectionByTwoProperties(
            res.results,
            'productId',
            'keyword'
          );
          this.originalData = [...this.searchModel.results];
          this.keywords = [];
          this.originalData.forEach(keyword => {
            this.keywords.push(keyword.keyword);
          });
        }
        this.searching = false;
        this.progressRef.complete();
        this.loadingIndicator = false;
      },
      () => {
        this.onAPIError(ProductUIMessages.LOAD_KEYWORDS_ERROR);
      }
    );
  }

  onAddItem(): void {
    this.dialogService
      .open(KeywordsAddComponent, [
        { provide: 'productId', useValue: this.productModel.id },
        { provide: 'existingKeywords', useValue: this.keywords },
        { provide: 'currentKeyword', useValue: null }
      ])
      .then(result => {
        if (result) {
          this.loadKeywordData();
        }
      })
      .catch(result => {
        // Silence is golden.
      });
  }

  onEditItem(row: any): void {
    this.dialogService
      .open(KeywordsAddComponent, [
        { provide: 'productId', useValue: this.productModel.id },
        { provide: 'existingKeywords', useValue: this.keywords },
        { provide: 'currentKeyword', useValue: row }
      ])
      .then(result => {
        if (result) {
          this.loadKeywordData();
        }
      })
      .catch(result => {
        // Silence is golden.
      });
  }

  onRowClick(event: any): void {
    if (this.authService.isAdmin() && event.type === 'click') {
      this.onEditItem(event.row);
    }
  }
}
